import { html, css, nothing, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import type { FullPageMessageAttributes } from 'zaptic-full-page-message'
import { getPathPrefix } from './helpers/href'

@customElement('zaptic-full-page-message')
export class FullPageMessage extends LitElement implements FullPageMessageAttributes {
    static styles = css`
        :host {
            display: flex;
            flex-direction: column;
            height: 100%;
            align-items: center;
            justify-content: center;
            margin: var(--FullPageMessage-margin);
        }

        .container {
            text-align: center;
            background: white;
            padding: var(--FullPageMessage-padding);
            max-width: var(--FullPageMessage-maxWidth);
        }

        .heading {
            margin: 12px 0;
            color: var(--navy);
            font-weight: var(--font-weight-medium);
            font-size: 20px;
            line-height: 28px;
        }
    `

    @property({ type: String, attribute: 'image' })
    imagePath?: string | null = null

    @property({ type: String })
    heading: string

    render() {
        const pathPrefix = getPathPrefix()

        return html`
            <div class="container">
                ${this.imagePath ? html`<img src="${pathPrefix}shared/images/${this.imagePath}" />` : nothing}
                <zaptic-spacer vertical-spacing="18"></zaptic-spacer>
                <div class="heading">${this.heading}</div>
                <slot></slot>
            </div>
        `
    }
}
